import type { DraftDetail } from "./types"

/**
 * Rechte Seite der Review-Card (60% Breite).
 * Zeigt Empfaenger-Zeile + editierbaren Draft-Text.
 *
 * Phase A: Draft ist plain-text editable via textarea.
 * Phase D: editable_spans mit inline-popovers, richtem Editor-Mode.
 */
export function DraftPanel({
  draft,
  onDraftChange,
  recipient,
  onRecipientChange,
  subject,
  onSubjectChange,
  editMode,
  onToggleEdit,
  hinweis,
}: {
  detail: DraftDetail
  /** Ueber dem Entwurf: woher der Text stammt, wenn er NICHT aus dem Plan
   *  kommt (Klassifikator-Entwurf vom Eingang). */
  hinweis?: React.ReactNode
  draft: string
  onDraftChange: (v: string) => void
  recipient: string
  onRecipientChange: (v: string) => void
  subject: string
  onSubjectChange: (v: string) => void
  editMode: boolean
  onToggleEdit: () => void
}) {
  return (
    <div style={{
      background: "#fff", border: "0.5px solid rgba(44,44,42,0.15)", borderRadius: 8,
      padding: 20, display: "flex", flexDirection: "column", gap: 12,
      overflow: "hidden",
    }}>
      {hinweis && (
        <div style={{
          fontSize: 12, color: "#9A6B0E", background: "#FDF6E3",
          border: "0.5px solid rgba(154,107,14,0.3)", borderRadius: 6, padding: "6px 10px",
        }}>
          {hinweis}
        </div>
      )}
      {/* Empfaenger + Subject */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingBottom: 10, borderBottom: "0.5px solid rgba(44,44,42,0.08)" }}>
        <Row label="An">
          <input
            value={recipient}
            onChange={(e) => onRecipientChange(e.target.value)}
            style={{ width: "100%", border: "none", fontSize: 13, color: "#2C2C2A", outline: "none", padding: 0 }}
          />
        </Row>
        <Row label="Betreff">
          <input
            value={subject}
            onChange={(e) => onSubjectChange(e.target.value)}
            style={{ width: "100%", border: "none", fontSize: 13, color: "#2C2C2A", outline: "none", padding: 0 }}
          />
        </Row>
      </div>

      {/* Draft-Body — scrollbar wenn laenger als Container */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflowY: "auto" }}>
        {editMode ? (
          <textarea
            value={draft}
            onChange={(e) => onDraftChange(e.target.value)}
            autoFocus
            style={{
              flex: 1, width: "100%", border: "none", outline: "none", resize: "none",
              fontSize: 13, lineHeight: 1.65, fontFamily: "inherit", color: "#2C2C2A",
              background: "transparent", padding: 0, minHeight: 280,
            }}
          />
        ) : (
          <div
            data-pii
            onDoubleClick={onToggleEdit}
            title="Doppelklick zum Bearbeiten (oder 'E' druecken)"
            style={{
              whiteSpace: "pre-wrap", fontSize: 13, lineHeight: 1.65, color: "#2C2C2A",
              cursor: "text",
            }}
          >
            {draft || <span style={{ color: "#888780", fontStyle: "italic" }}>(leer)</span>}
          </div>
        )}
      </div>

      {/* Footer Meta-Zeile */}
      <div style={{
        fontSize: 12, color: "#888780", display: "flex", justifyContent: "space-between",
        paddingTop: 10, borderTop: "0.5px solid rgba(44,44,42,0.08)",
      }}>
        <span>{editMode ? "Bearbeiten-Modus · Esc = fertig" : "Doppelklick oder 'E' zum Bearbeiten"}</span>
        <span>Ton: Professionell · Sie-Form</span>
      </div>
    </div>
  )
}

function Row({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "baseline" }}>
      <span style={{
        fontSize: 12, textTransform: "uppercase", letterSpacing: 0.5,
        color: "#888780", fontWeight: 500, width: 60, flexShrink: 0,
      }}>
        {label}
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
    </div>
  )
}
